import login from './login/login_es'
import forgotPassword from './forgotPassword/forgotPassword_es'
import changePassword from './changePassword/changePassword_es'
import home from './home/home_es'
import termsAndConditions from './termsAndConditions/termsAndConditions_es'
import updatePassword from './updatePassword/updatePassword_es';
import settlements from './settlements/settlements_es'
import authorizationTypes from './authorization/types/types_es';
import outpatientCare from './authorization/outpatient-care/outpatient-care_es';
import doctorFields from './authorization/outpatient-care/doctor-fields/doctor-fields_es';
import identityValidation from './authorization/outpatient-care/identity-validation/identity-validation_es';
import beneficiaryResults from './authorization/outpatient-care/beneficiary-results/beneficiary-results_es';
import createSettlement from './settlements/create-settlement/create-settlement_es';
import filters from './filters/filters_es'
import settlementDetail from './settlements/settlement-detail_es'

import addAuthorization from './addAuthorization/es'
import authorizationList from './authorizationList/es'
import authorizationDetail from './authorizationDetail/es'
import profile from './profile/profile_es'
import tfa from './tfa/tfa_es'

export default {
  globalErrorUnknown: '¡Tuvimos un problema técnico! Por favor, intente de nuevo o contacte a su equipo de soporte técnico.',
  loading: 'Cargando',
  errorTitle: 'Ha ocurrido un error',
  defaultErrorDescription: 'Por favor contacte al equipo de soporte técnico para mayor información.',
  badCredentials: '¡Credenciales incorrectas! Por favor, intente de nuevo.',
  buttons: {
    close: 'Cerrar',
    save: 'Guardar',
    delete: 'Eliminar'
  },
  errors: {
    inputValidations: {
      required: 'Requerido',
      invalidFormat: 'El formato es incorrecto',
      maxLength: 'Se ha excedido el límite de {n} caracteres',
      minLength: 'Mínimo {n} caracteres',
      invalidFile: "El tipo de archivo es inválido",
      invalidFileSize: "El archivo excede el tamaño máximo permitido",
      maxFiles: "Se ha excedido el límite de archivos ({n})",
      fileRequired: "Adjuntar un archivo es requerido",
      ClaimTypeRequired: "El tipo de solicitud es requerido",
      authorizationTypeRequired: "El tipo de autorización es requerido",
      invalid: "Valor inválido",
      invalidDate: "La fecha es inválida.",
      beneficiaryRequired: 'El beneficiario es requerido.',
      invalidBirthday: 'La fecha de nacimiento es inválida.',
    }
  },
  drawer: {
    logout: 'Cerrar sesión'
  },
  footer: {
    privacyLabel: 'Privacidad'
  },
  locales: {
    es: 'Español',
    en: 'Ingles'
  },
  identityDocumentTypes: {
      passport: 'Pasaporte',
      nationalIdentityCard: 'Número de identificación nacional',
      socialSecurityNumber: 'Número de seguro social',
      taxIdentificationNumber: 'Número de identificación tributaria',
      electoralRegistryNumber: 'Número de identificación electoral'
  },
  genders: {
    male: 'Hombre',
    female: 'Mujer'
  },
  posology: {
      day: ' día | días',
      unit: 'unidad | unidades',
      medicalDeviceDescription: 'Usar {0} ({1}) {2} por {3} ({4}) {5}',
      half: 'medio/a',
      quarter: ' un cuarto | {value} cuartos',
      andConnector: 'y',
      pointConnector: 'punto',
  },
  emptyList: {
    desktop: 'No se encontraron resultados',
    mobile: {
      prefix: 'No se encontraron ',
      sufix: 'resultados'
    }
  },
  emptyListDescription: {
    prefix: 'Intente buscando otro término',
    middle: 'o',
    sufix: 'aplicados.'
  },
  chronicTreatmentLabel: 'Tratamiento crónico',
  login,
  forgotPassword,
  changePassword,
  home,
  termsAndConditions,
  updatePassword,
  settlements,
  authorizationTypes,
  outpatientCare,
  doctorFields,
  identityValidation,
  beneficiaryResults,
  filters,
  settlementDetail,
  createSettlement,
  addAuthorization,
  authorizationList,
  authorizationDetail,
  profile,
  tfa
}
